export type TipoDeAviso = 'exito' | 'error' | 'advertencia' | 'informacion';

export interface Aviso {
  id: number;
  tipo: TipoDeAviso;

  titulo?: string | undefined;
  mensaje: string;
}

const DURACION: Record<TipoDeAviso, number> = {
  exito: 4000,
  informacion: 5000,
  advertencia: 5000,
  error: 7000,
};

const MAXIMO = 4;

let avisos: Aviso[] = [];
let siguienteId = 1;

const oyentes = new Set<() => void>();
const relojes = new Map<number, ReturnType<typeof setTimeout>>();

function emitir(): void {
  for (const oyente of oyentes) {
    oyente();
  }
}

function agregar(tipo: TipoDeAviso, mensaje: string, titulo?: string): number {
  const id = siguienteId++;

  avisos = [...avisos, { id, tipo, mensaje, titulo }].slice(-MAXIMO);
  emitir();

  relojes.set(
    id,
    setTimeout(() => descartar(id), DURACION[tipo]),
  );

  return id;
}

export function descartar(id: number): void {
  const reloj = relojes.get(id);
  if (reloj !== undefined) {
    clearTimeout(reloj);
    relojes.delete(id);
  }

  const quedan = avisos.filter((a) => a.id !== id);
  if (quedan.length === avisos.length) {
    return;
  }

  avisos = quedan;
  emitir();
}

export function suscribir(oyente: () => void): () => void {
  oyentes.add(oyente);
  return () => oyentes.delete(oyente);
}

export function leer(): Aviso[] {
  return avisos;
}

export const notificar = {
  exito: (mensaje: string, titulo?: string) => agregar('exito', mensaje, titulo),
  error: (mensaje: string, titulo?: string) => agregar('error', mensaje, titulo),
  advertencia: (mensaje: string, titulo?: string) => agregar('advertencia', mensaje, titulo),
  informacion: (mensaje: string, titulo?: string) => agregar('informacion', mensaje, titulo),
};
